import Vue from 'vue'
import Vuex from 'vuex'
import Resource from 'vue-resource'

Vue.use(Vuex)
Vue.use(Resource)

const LOAD_REQUEST = 'LOAD_REQUEST'
const LOAD_SUCCESS = 'LOAD_SUCCESS'
const LOAD_ERROR = 'LOAD_ERROR'
const QUESTION_SET = 'QUESTION_SET'
const RESULT_SET = 'RESULT_SET'
const SUMMARY_PUSH = 'SUMMARY_PUSH'
const SUMMARY_POP = 'SUMMARY_POP'
const SUMMARY_RESET = 'SUMMARY_RESET'
const AK_SET_MANUALLY = 'AK_SET_MANUALLY'

export default new Vuex.Store({
  state: {
    loadStatus: null,
    tree: null,
    labels: null,
    question: null,
    result: null,
    summary: []
  },
  mutations: {
    [LOAD_REQUEST]: (state, data) => {
      state.loadStatus = LOAD_REQUEST
    },
    [LOAD_SUCCESS]: (state, data) => {
      state.loadStatus = LOAD_SUCCESS
      state.tree = Object.assign({}, data.stages)
      state.labels = Object.assign({}, data.labels)
      state.question = state.tree['ak'].trunks['root']
    },
    [LOAD_ERROR]: (state, data) => {
      state.loadStatus = LOAD_ERROR
    },
    [QUESTION_SET]: (state, data) => {
      console.log(data)
      state.question = data
      state.result = null
    },
    [RESULT_SET]: (state, data) => {
      state.question = null
      state.result = data
    },
    [SUMMARY_PUSH]: (state, data) => {
      state.summary.push(data)
    },
    [SUMMARY_POP]: (state, data) => {
      const start = state.summary.indexOf(data)
      const count = state.summary.length - start + 1
      state.summary.splice(start, count)
    },
    [SUMMARY_RESET]: (state, data) => {
      state.summary = []
      state.result = null
      state.question = state.tree['ak'].trunks['root']
    },
    [AK_SET_MANUALLY]: (state, data) => {
      state.summary.push({result: data, note: null})
      state.question = state.tree['rk'].trunks[data]
    }
  },
  actions: {
    loadData ({
      commit,
      state
    }) {
      commit(LOAD_REQUEST, null)
      Vue.http.get(window['cert-app-data-path'])
        .then(response => response.json())
        .then(json => {
          commit(LOAD_SUCCESS, json)
        }, response => {
          commit(LOAD_ERROR)
        })
    },
    optionSelect ({
      commit,
      state
    }, data) {
      const question = data.question
      const option = data.option
      const child = option.child

      commit(SUMMARY_PUSH, {
        question,
        option
      })

      if (child.options) {
        // If child of selected option is a question
        commit(QUESTION_SET, child)
      } else if (child.result) {
        // If child of selected option is a result
        const split = child.result.path.split('>')
        const stageId = split[0]
        const trunkId = split[1]

        const stage = state.tree[stageId]

        if (stageId && trunkId) {
          // The result leads to a new trunk
          const trunk = stage.trunks[trunkId]
          if (trunk.options) {
            // New trunk has further question(s)
            commit(QUESTION_SET, trunk)
            commit(SUMMARY_PUSH, {result: trunkId, note: child.result.note})
          } else {
            // New trunk contains the final result as the first item
            commit(SUMMARY_PUSH, {result: trunkId, note: child.result.note})
            commit(SUMMARY_PUSH, {result: trunk.result.path, note: trunk.result.note})
            commit(RESULT_SET, {result: trunk.result.path, note: trunk.result.note})
          }
        } else {
          // The result does not lead to a new trunk, therefore final result
          commit(SUMMARY_PUSH, {result: stageId, note: child.note})
          commit(RESULT_SET, {result: stageId, note: child.note})
        }
      }
    },
    summarySelect ({
      commit,
      state
    }, data) {
      commit(SUMMARY_POP, data)
      commit(QUESTION_SET, data.question)
    },
    summaryReset ({
      commit,
      state
    }, data) {
      commit(SUMMARY_RESET)
    },
    setAk ({
      commit,
      state
    }, data) {
      commit(AK_SET_MANUALLY, data)
    }
  },
  getters: {
    loadStatus: state => state.loadStatus,
    tree: state => state.tree,
    labels: state => state.labels,
    question: state => state.question,
    result: state => state.result,
    summary: state => state.summary
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js